import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {deserialize} from '@app/serializable';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

export class SubscriptionItem {
    quantity: number;
    unit_amount: number;
    interval: string;
    product: string;
}

export class Subscription {
    id: string;
    interval: string;
    email: string;
    last4: number;
    status: string;
    current_period_end: number;
    cancel_at: number;
    canceled_at: number;
    storage_unit_amount: number;
    items: SubscriptionItem[];
}

@Injectable({
    providedIn: 'root',
})
export class BillingService {
    constructor(private http: HttpClient) {}

    getBillingInfo(): Observable<Subscription> {
        const url = `/api/workspace/subscription/`;
        const options = {
            withCredentials: true,
        };
        return this.http.post(url, options).pipe(
            filter((result) => Boolean(result)),
            map((result) => deserialize(Subscription, result)),
        );
    }

    openBillingPortal(): Observable<any> {
        const options = {
            withCredentials: true,
        };
        return this.http.post<any>(`/api/workspace/subscription/portal/`, options);
    }

    createSubscription(options): Observable<any> {
        const requestOptions = {
            withCredentials: true,
        };
        Object.assign(requestOptions, options);
        return this.http
            .post<any>('api/workspace/subscription/upgrade/', requestOptions)
            .pipe(map((response: any) => response.url));
    }

    invoicePreview(seats: number, interval: number, code: string): Observable<any> {
        const options = {
            code,
            seats,
            interval,
            withCredentials: true,
        };
        return this.http.post<any>(`/api/workspace/subscription/invoice/`, options);
    }

    pricing(): Observable<any> {
        return this.http.get<any>(`/api/workspace/subscription/pricing/`);
    }
}
